import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { Phone } from 'lucide-react';
const flow = ['LLAMADA ENTRANTE', 'VOICE', 'IDENTIFICA', 'ENTIENDE', 'CALIFICA', 'AGENDA', 'CRM', 'SEGUIMIENTO'];
export function Voice() {
  return <section id="voice" className="bg-carbon py-[100px] md:py-[150px]" data-id="element-248" data-mp="b6qytrgscd9f">
      <div className="max-w-[900px] mx-auto px-6 md:px-16" data-id="element-249" data-mp="68fqjl652atb">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="text-center max-w-[560px] mx-auto mb-10" data-id="element-250" data-mp="k99wzy9mm1pc">
          <span className="inline-flex items-center gap-1.5 font-body text-[11px] uppercase tracking-[0.15em] text-salvia mb-5" data-id="element-251" data-mp="p0s28yiomog4">
            <Phone size={12} data-id="element-252" data-mp="13yu5t8ppr9xd" /> ORIGEN / VOICE
          </span>
          <h2 className="font-display text-[28px] md:text-[40px] font-medium text-arena leading-[1.15] mb-4" data-id="element-253" data-mp="yyo7j9oxup6b">
            Tu empresa también puede contestar el teléfono.
          </h2>
          <p className="font-body text-[16px] md:text-[18px] text-arena/55 leading-[1.6]" data-id="element-254" data-mp="1vpco2d9dszui">
            Un agente de voz con IA que atiende, entiende, califica, agenda,
            registra y deriva cuando hace falta.
          </p>
        </motion.div>

        <div className="flex flex-wrap items-center justify-center gap-1.5 mb-12" data-id="element-255" data-mp="29nu9g4bte099">
          {flow.map((step, idx) => <Fragment key={step} data-id="element-256" data-mp="2ellxuod9348p" data-mpi={idx}>
              <span className="font-body text-[11.5px] text-arena/60 border border-arena/15 px-3 py-1.5" data-id="element-257" data-mp="2jkys3u6gbdlb">
                {step}
              </span>
              {idx < flow.length - 1 && <span className="text-arena/25 text-[12px]" data-id="element-258" data-mp="2sd95fkcn7z6s">→</span>}
            </Fragment>)}
        </div>

        {/* System trace — 3 numbered stages, not a chat UI */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6 max-w-[820px] mx-auto" data-id="element-259" data-mp="2xaiuv0018aum">
          {/* 01 Incoming call */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.35,
          ease: 'easeOut'
        }} className="border-t border-arena/15 pt-5" data-id="element-260" data-mp="128fe2wz0m2vv">
            <span className="block font-body text-[11px] text-salvia tracking-[0.1em] mb-4" data-id="element-261" data-mp="177rxt8ulatu8">
              01 / LLAMADA ENTRANTE
            </span>
            <p className="font-body text-[13px] text-arena/85 mb-2" data-id="element-262" data-mp="1kxvgjpu9g5ex">
              <span className="text-arena/40" data-id="element-263" data-mp="1gx1t0xkqcsmk">Cliente — </span>
              "Hola, quiero saber si tienen disponibilidad esta semana."
            </p>
            <p className="font-body text-[13px] text-arena font-medium" data-id="element-264" data-mp="1uvi8pe0kltgu">
              <span className="text-verde" data-id="element-265" data-mp="1pzksd7pb4n42">VOICE — </span>
              "Claro. ¿Qué servicio necesitas?"
            </p>
          </motion.div>

          {/* 02 Understanding */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.35,
          ease: 'easeOut',
          delay: 0.1
        }} className="border-t border-arena/15 pt-5" data-id="element-266" data-mp="3rrg0xeg9obi2">
            <span className="block font-body text-[11px] text-salvia tracking-[0.1em] mb-4" data-id="element-267" data-mp="1xhizx6nxho4n">
              02 / ENTENDIMIENTO
            </span>
            <div className="space-y-1.5" data-id="element-268" data-mp="1ohm3ujz7lmzk">
              <p className="font-body text-[13px] text-arena/75" data-id="element-269" data-mp="1ogkqg8uq0oeo">
                SERVICE <span className="text-arena float-right" data-id="element-270" data-mp="1th8imxuorbah">Consulta</span>
              </p>
              <p className="font-body text-[13px] text-arena/75" data-id="element-271" data-mp="1ejogrzt35w8j">
                INTENTION <span className="text-arena float-right" data-id="element-272" data-mp="1elsvlcsiwfnl">Alta</span>
              </p>
              <p className="font-body text-[13px] text-arena/75" data-id="element-273" data-mp="1jirndoopsaim">
                SCHEDULE{' '}
                <span className="text-arena float-right" data-id="element-274" data-mp="38y8wrz6gp3ll">Jueves · 15:00</span>
              </p>
            </div>
          </motion.div>

          {/* 03 System action */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.35,
          ease: 'easeOut',
          delay: 0.2
        }} className="border-t border-arena/15 pt-5" data-id="element-275" data-mp="1dt9mql4jkv4q">
            <span className="block font-body text-[11px] text-salvia tracking-[0.1em] mb-4" data-id="element-276" data-mp="ztqdtq3wpfrd">
              03 / ACCIÓN DEL SISTEMA
            </span>
            <div className="space-y-1.5" data-id="element-277" data-mp="q4qdo3do4ebl">
              <p className="font-body text-[13px] text-arena/85 flex justify-between" data-id="element-278" data-mp="q3nmducfo9v5">
                CRM <span className="text-verde" data-id="element-279" data-mp="m2brb9asiwfk">UPDATED ✓</span>
              </p>
              <p className="font-body text-[13px] text-arena/85 flex justify-between" data-id="element-280" data-mp="h4acj0kedj9w">
                AGENDA <span className="text-verde" data-id="element-281" data-mp="c4o02tce8725">BOOKED ✓</span>
              </p>
              <p className="font-body text-[13px] text-arena/85 flex justify-between" data-id="element-282" data-mp="c6s0v2ezwpy7">
                FOLLOW-UP <span className="text-verde" data-id="element-283" data-mp="786z2yk3hy7n">ACTIVE ✓</span>
              </p>
            </div>
          </motion.div>
        </div>

        <p className="font-body text-[13px] text-arena/45 max-w-[440px] mx-auto mt-12 mb-6 text-center leading-[1.6]" data-id="element-284" data-mp="20hbdqvp335m">
          VOICE se integra con tu sistema de atención para calificar
          oportunidades, agendar y ejecutar acciones.
        </p>

        <div className="text-center" data-id="element-285" data-mp="byeww6m66luj">
          <a href="#precios" className="inline-flex items-center gap-1.5 font-display font-medium text-[14px] text-arena hover:text-verde transition-colors duration-150" data-id="element-286" data-mp="3ah2dcnpwsvz8">
            Ver planes VOICE <span aria-hidden="true" data-id="element-287" data-mp="3kdynexvghq5w">→</span>
          </a>
        </div>
      </div>
    </section>;
}